import { SHORT_TEXT_INPUT_MAX_LENGTH } from '@shared/sec-loans'
import { hasPostalCodeOnly, validateShortTextInput } from '@ui-common/utils/validation'
import { FieldPath } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, only, Suite, test } from 'vest'

import { AddressInfoFormData } from './types'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: AddressInfoFormData, changedFields?: FieldPath<AddressInfoFormData>[]) => void> => {
  return create((data, changedFields) => {
    only(changedFields)

    validateShortTextInput('street', formatMessage, data.street, SHORT_TEXT_INPUT_MAX_LENGTH)
    test('postalCode', formatMessage({ id: 'validate-required-field-missing' }), () => {
      enforce(data.postalCode).isNotEmpty()
    })
    test('postalCode', formatMessage({ id: 'validate-common-finnish-postcode-length' }), () => {
      enforce(data.postalCode).hasPostalCodeOnly()
    })
    omitWhen(!hasPostalCodeOnly(data.postalCode ?? '') || data.postOffice === undefined, () => {
      test('postalCode', formatMessage({ id: 'common-unknown-postcode' }), () => {
        enforce(data.postOffice).isNotNull()
        enforce(data.postOffice).longerThan(0)
      })
    })
  })
}
